import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/blog/page.tsx");
